const config = {
  apiUrl: "https://smt.soportedinamico.com/tavo_backend/public/api/",
  socketUrl: "https://smt.soportedinamico.com:6001",
  //apiUrl: "http://localhost/tavo/tavo_backend/public/api/",
  //socketUrl: "https://localhost:6001"
};

export default config;
